import React, { useContext } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Box } from "@mui/material";

import { GRNProvider, GRNContext } from "./Context/GRNContext";

import Sidebar from "./Sidebar/Sidebar";
import Dashboard from "./Dashboard/Dashboard";
import Header from "./components/Header";
import SignIn from "./Authorization/SignIn";
import ProtectedRoute from "./ProtectedRoute";
import GrnSubmission from "./components/GRNSubmission";
import GrnRecords from "./components/GrnRecords";
import ScheduledReminders from "./components/ScheduledReminders";

function HomeRoute() {
  const { isAuthenticated } = useContext(GRNContext);

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return <SignIn />;
}

function AppContent() {
  const { isAuthenticated } = useContext(GRNContext);

  return (
    <>
      {isAuthenticated && <Header />}

      <Box
        sx={{
          display: "flex",
          height: "calc(100vh - 64px)",
          overflow: "hidden",
        }}
      >
        {isAuthenticated && <Sidebar />}

        <Box
          sx={{
            flex: 1,
            overflowY: "auto",
            overflowX: "hidden",
            background: "#ecf0f3",
          }}
        >
          <Routes>
            <Route path="/login" element={<HomeRoute />} />

            <Route element={<ProtectedRoute />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/form" element={<GrnSubmission /> } />  
              <Route path="/records" element={<GrnRecords />} />
              <Route path="/scheduled-reminders" element={<ScheduledReminders />} />
            </Route>

            <Route
              path="*"
              element={
                isAuthenticated ? (
                  <Navigate to="/dashboard" replace />
                ) : (
                  <Navigate to="/login" replace />
                )
              }
            />
          </Routes>
        </Box>
      </Box>
    </>
  );
}

export default function App() {
  return (
    <GRNProvider>
      <AppContent />
    </GRNProvider>
  );
}